export interface CubeProps {
  items: ItemList
  startDelayMillis?: number
}

export interface MeshProps {
  items: ItemList
  onFaceClick: (index: number) => void
  startDelayMillis?: number
}

export enum ItemType {
  IMAGE,
  COUNTDOWN,
  KANDI,
  VIDEO,
}

export type Item = {
  type: ItemType
  src?: string
  videoSrc?: string
  kandi?: {
    outline: string
    firstname: string
    lastname: string
  }
  link?: string
  targetDate?: Date
  openExternal?: boolean
}

export type ItemList = [Item, Item, Item, Item, Item, Item?]
